import * as Yup from "yup"

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Название баннера обязательно"),
  image: Yup.string().required(),
  url: Yup.string().url("Неправильный формат ссылки").required("Ссылка обязательна"),
})
